import React from 'react';
import { connect } from 'react-redux';
import { Actions as USAGEACTIONS } from '../../store/actions/usageActions';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';

const DeleteUsageDataModal = ({ usageDataDeleteModal, showUsageDataDeleteModal, deleteUsageData }) => {
  const open = !!usageDataDeleteModal?.status;

  if (!open) return null;

  const handleClose = () => showUsageDataDeleteModal(false, null);

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) handleClose();
      }}>
      <DialogContent onClose={handleClose} className='gap-0 p-0 max-w-xl font-body'>
        <DialogHeader className='space-y-2 border-b border-border px-6 pb-4 pt-6 pr-14 text-left'>
          <DialogTitle className='font-display text-lg leading-snug'>
            Are you sure you wish to delete this usage data?
          </DialogTitle>
          <DialogDescription className='text-sm text-muted-foreground'>
            This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className='flex flex-row flex-nowrap items-center justify-end gap-2 border-t border-border bg-muted/30 px-6 py-4'>
          <Button
            id='cancel-usage-deletion'
            variant='outline'
            className='shrink-0'
            onClick={handleClose}>
              Cancel (do not delete data)
          </Button>
          <Button
            variant='destructive'
            className='shrink-0'
            onClick={() => deleteUsageData([usageDataDeleteModal.item])}>
              Yes, please delete this data
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

const mapStateToProps = (state) => {
  return {
    usageDataDeleteModal: state.usageDataDeleteModal,
  };
};

const mapDispatchToProps = (dispatch) => ({
  deleteUsageData: (items) => dispatch(USAGEACTIONS.deleteUsageData(items)),
  showUsageDataDeleteModal: (status, item) => dispatch(USAGEACTIONS.showUsageDataDeleteModal(status, item)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteUsageDataModal);
